// Fallback landing order used when the user lacks `report.view` (so the Home→dashboard
// redirect in router/index.js can't send them there) — mirrors the top-to-bottom order of
// gated items in examples/Sidenav/SidenavList.vue. Kept as a separate ordered list rather than
// derived from the sidebar template, since the sidebar has non-navigable/admin-only entries
// mixed in; duplicate perm_keys here are harmless, the first one satisfied wins.
const FALLBACK_SECTIONS = [
    { path: '/users', permKey: 'communication.users.list' },
    { path: '/user-reports', permKey: 'report.view' },
    { path: '/cohorts', permKey: 'cohorts.view' },
    { path: '/broadcasting', permKey: 'tasker.task.view' },
    { path: '/utm-builder', permKey: 'settings.view' },
    { path: '/workflows', permKey: 'workflows.view' },
    { path: '/integrations', permKey: 'integrations.view' },
    { path: '/referral', permKey: 'report.view' },
    { path: '/database/events', permKey: 'database.view' },
    { path: '/webapps', permKey: 'webapp.view' },
    { path: '/custom-fields', permKey: 'custom_fields.view' },
    { path: '/bot_errors', permKey: 'errors.view' },
];

// Always accessible regardless of per-resource perm_keys (cross-resource bot list, not
// gated — see SidenavList.vue) — the landing spot when the user has no granted perm_key at all.
const UNGATED_FALLBACK_PATH = '/resorces';

export function getFirstAccessibleSection(store) {
    const can = store.getters['init/can'];
    const match = FALLBACK_SECTIONS.find(section => can(section.permKey));
    return match ? match.path : UNGATED_FALLBACK_PATH;
}
